module.exports = __webpack_public_path__ + "static/media/pic1.01e4e4fd.png";